import { z } from 'zod';

export const HTTP_METHODS = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE', 'HEAD', 'OPTIONS'] as const;
export const API_STATUS = ['active', 'deprecated', 'disabled'] as const;
export const AUTH_POLICIES = ['none', 'jwt', 'api-key', 'oauth2'] as const;

export const apiFormSchema = z.object({
  name: z.string().min(2, '최소 2자').max(80, '최대 80자'),
  method: z.enum(HTTP_METHODS),
  path: z
    .string()
    .min(1, '경로를 입력하세요')
    .max(200)
    .regex(/^\/[^\s]*$/, '/ 로 시작해야 합니다'),
  version: z
    .string()
    .regex(/^v\d+$/, 'v1, v2 형식이어야 합니다'),
  status: z.enum(API_STATUS).default('active'),
  description: z.string().max(500).optional(),
  authPolicy: z.enum(AUTH_POLICIES).default('jwt'),
  requiredRoles: z.array(z.string()).default([]),
  rbac: z.record(z.array(z.enum(['read', 'write']))).optional(),
  rateLimitPolicyId: z.preprocess(
    (v) => (v === '' || v == null ? null : v),
    z.string().uuid().nullable().optional(),
  ),
  enabled: z.boolean().default(true),
});

export type ApiFormValues = z.infer<typeof apiFormSchema>;
